// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"124":"253bacce","585":"d8178acb","641":"f22cddee","765":"8f4b83ba","780":"1004693d","814":"74a46bec","889":"ef829167"}[chunkId] + ".js";
};